import { Box } from "@chakra-ui/layout";
import { Stack, Divider, useDisclosure } from "@chakra-ui/react";
import { IFAQ } from "interfaces/faq.interface";
import { HiOutlinePlus } from "react-icons/hi";

export const FAQItem = ({ title, children }) => {
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure({
    isOpen: true
  });

  return (
    <Box css={{ breakInside: "avoid" }} display="inline-block">
      <Box
        display="flex"
        cursor="pointer"
        onClick={onToggle}
        _hover={{
          color: "primary.600",
        }}
      >
        <Box fontSize="lg" fontWeight={600} mb={3}>
          {title}
        </Box>
        {/* <Box
          ml="auto"
          minW={8}
          h={8}
          display="flex"
          bg="gray.100"
          alignItems="center"
          justifyContent="center"
          fontSize="xl"
          rounded="md"
          color="gray.500"
        >
          <HiOutlinePlus />
        </Box> */}
      </Box>
      {isOpen && <Box color="gray.700">{children}</Box>}
    </Box>
  );
};

export const FAQS = ({ faqs }: { faqs: IFAQ[] }) => {
  return (
    <Box>
      <Stack spacing={6}>
        {faqs &&
          faqs.map((faq) => {
            return <FAQItem title={faq.question}>{faq.answer}</FAQItem>;
          })}
      </Stack>
    </Box>
  );
};